var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file sidebar
 * @author (zhuwanying02) if any problem, please call me.
 */

import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash-es';

import { classPrefix } from '../../common/util';

import Tips from '../Tips';

import './Sidebar.less';

/* global document */

/*
 *  参数说明
 *  mode                  非必需，stack,tree(default) 两种模式。
 *                        建议dataSource数据内容较少时，使用分组类型；数据内容过多，且层级较多时采用树型折叠模式
 *                          (!!!注意stack模式下，不支持horizontal排列)
 *  horizontal            非必需，与tree模式(default)结合使用，水平导航列表
 *  selectedKeys          非必需，设置默认选中
 *  openKeys              非必需，设置默认展开
 *  defaultHoveredKey     非必需，设置默认hover
 *  dataSource            必需，树型结构数据
 *                            比如 [{key:'',content:'',icon:'',children:[{}]},{}]
 *                            其中key,content必需，icon,children非必需
 *  style                 非必需
 *  className             非必需
 *  onHandleClick         非必需 点击回调
 *  onlyIcon              非必需 仅显示icon
 *  defaultOnlyShowIcon   非必需 仅显示图标模式下初始状态展开还是收起
 *  theme                 非必需 主题色 string: light/dark
 *  title                 非必需 sidebar标题
 *  logo                  非必需 sidebarlogo
 *  tipsLevel             非必需 tips组件属性
 *  tipsFixed             非必需 tips组件属性
 *  classPrefix           非必需 类名前缀
 */

var Sidebar = function (_Component) {
    _inherits(Sidebar, _Component);

    function Sidebar(props) {
        _classCallCheck(this, Sidebar);

        var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

        _this.bodyScroll = function () {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var scrollMarginTop = _this.props.scrollMarginTop;
            if (scrollTop >= 0 && scrollTop < scrollMarginTop) {
                _this.setState({ ulMarginTop: scrollMarginTop - scrollTop });
            } else {
                _this.setState({ ulMarginTop: 0 });
            }
        };

        var openKeys = props.openKeys,
            selectedKeys = props.selectedKeys,
            defaultOnlyShowIcon = props.defaultOnlyShowIcon,
            dataSource = props.dataSource;


        var openKeysObj = {};
        if (openKeys) {
            openKeys.forEach(function (v) {
                openKeysObj[v] = true;
            });
        }

        _this.state = {
            selectedKeys: selectedKeys || [],
            openKeys: openKeysObj,
            hoveredKey: '',
            isOnlyShowIcon: defaultOnlyShowIcon,
            ulMarginTop: _this.props.scrollMarginTop
        };

        _this.pathInfo = {}; // 用于存放路径信息
        _this.parentItem = []; // 保存dataSource的第一层数据

        _this.updataDataSourceRelativeInfo(dataSource);
        return _this;
    }

    _createClass(Sidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var selectedKeys = this.state.selectedKeys[0];

            if (selectedKeys && this.pathInfo[selectedKeys]) {
                var pathkey = this.pathInfo[selectedKeys].pathkey;
                var openKeys = {};

                pathkey.forEach(function (v) {
                    openKeys[v] = true;
                });

                this.setState({
                    openKeys: openKeys
                }, function () {
                    _this2.scrollToLocate(selectedKeys);
                });
            }
            // navbar固定样式的滚动监听
            if (this.props.fixed === 'scroll') {
                document.addEventListener('scroll', this.bodyScroll);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.fixed === 'scroll') {
                document.removeEventListener('scroll', this.bodyScroll);
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            var _this3 = this;

            var _state = this.state,
                selectedKeys = _state.selectedKeys,
                openKeys = _state.openKeys,
                defaultHoveredKey = _state.defaultHoveredKey,
                isOnlyShowIcon = _state.isOnlyShowIcon;


            if ('selectedKeys' in newProps && !_.isEqual(selectedKeys, newProps.selectedKeys)) {
                this.setState({
                    selectedKeys: newProps.selectedKeys
                });

                var newSelectedKey = newProps.selectedKeys[0];

                if (newSelectedKey && this.pathInfo[newSelectedKey]) {
                    var pathkey = this.pathInfo[newSelectedKey].pathkey;

                    var _openKeys = {};
                    pathkey.forEach(function (v) {
                        _openKeys[v] = true;
                    });

                    this.setState({
                        openKeys: _openKeys
                    }, function () {
                        _this3.scrollToLocate(newSelectedKey);
                    });
                }
            }

            if ('openKeys' in newProps && !_.isEqual(openKeys, newProps.openKeys)) {
                var openKeysObj = {};

                newProps.openKeys.forEach(function (v) {
                    openKeysObj[v] = true;
                });

                this.setState({
                    openKeys: openKeysObj
                });
            }

            if ('defaultHoveredKey' in newProps) {
                if (!_.isEqual(defaultHoveredKey, newProps.defaultHoveredKey)) {
                    this.setState({
                        hoveredKey: _.assign([], newProps.defaultHoveredKey)
                    });
                }
            }

            if ('defaultOnlyShowIcon' in newProps) {
                if (!_.isEqual(isOnlyShowIcon, newProps.defaultOnlyShowIcon)) {
                    this.setState({
                        isOnlyShowIcon: newProps.defaultOnlyShowIcon
                    });
                }
            }

            // 若dataSource数据改变，则更新this.pathInfo和this.parentItem的信息
            if (!_.isEqual(this.props.dataSource, newProps.dataSource)) {
                this.updataDataSourceRelativeInfo(newProps.dataSource);
            }
        }
    }, {
        key: 'updataDataSourceRelativeInfo',
        value: function updataDataSourceRelativeInfo(dataSource) {
            var _this4 = this;

            this.parsePath(dataSource);
            dataSource.forEach(function (v) {
                _this4.parentItem.push(v.key);
            });
        }
    }, {
        key: 'scrollToLocate',
        value: function scrollToLocate(key) {
            if (key) {
                var menuRoot = this.menuRoot;
                var firstEle = menuRoot.firstChild;
                var currentEle = this[key];

                if (currentEle) {
                    var currentOffset = currentEle.getBoundingClientRect();
                    var firstOffset = firstEle.getBoundingClientRect();

                    var viewportHeight = menuRoot.clientHeight;
                    var offsetTop = currentOffset.top - firstOffset.top;

                    if (currentOffset.top > 0) {
                        if (viewportHeight < offsetTop + 200) {
                            menuRoot.scrollTop = offsetTop - viewportHeight + 200;
                        }
                    } else {
                        menuRoot.scrollTop = 0;
                    }
                }
            }
        }

        // === 解决获取节点全路径

    }, {
        key: 'parsePath',
        value: function parsePath(dataSource) {
            this.getParentKey(dataSource);
            for (var i in this.pathInfo) {
                if (!this.pathInfo[i].parent) {
                    this.pathInfo[i].pathkey.push(i);
                } else {
                    this.pathInfo[i].pathkey.push(i);
                    this.getPath(i, this.pathInfo[i].parent);
                }
            }
        }
    }, {
        key: 'getPath',
        value: function getPath(key, parent) {
            this.pathInfo[key].pathkey.push(parent);
            if (this.pathInfo[parent].parent) {
                this.getPath(key, this.pathInfo[parent].parent);
            }
        }
    }, {
        key: 'getParentKey',
        value: function getParentKey(children, parent) {
            if (!children || children.length === 0) {
                return;
            }

            for (var i = 0, len = children.length; i < len; i++) {
                var child = children[i];

                if (!child || !child.key) {
                    break;
                }

                this.pathInfo[child.key] = {
                    key: child.key,
                    parent: parent,
                    pathkey: []
                };
                if (child.children) {
                    this.getParentKey(child.children, child.key);
                }
            }
        } // === end

        // =============================
        // ========== 树型模式 ==========
        // =============================

    }, {
        key: 'handleSelectOrExpanded',
        value: function handleSelectOrExpanded(value) {
            var _props = this.props,
                onHandleClick = _props.onHandleClick,
                horizontal = _props.horizontal;

            var openKeys = this.state.openKeys;

            if (value.children) {
                if (horizontal) {
                    return;
                }
                openKeys[value.key] = !openKeys[value.key];

                this.setState({
                    openKeys: openKeys
                });
            } else {
                value.pathkey = this.pathInfo[value.key].pathkey;

                // 留给外部控制，避免路由拦截的时候出现显示问题
                // this.setState({
                //     selectedKeys: value.pathkey
                // });

                if (onHandleClick && _.isFunction(onHandleClick)) {
                    onHandleClick(value);
                }
            }
        }

        // 用js的方式实现hover效果，代替伪类:hover

    }, {
        key: 'handleHoverEnter',
        value: function handleHoverEnter(value) {
            this.setState({
                hoveredKey: value.key
            });
        }
    }, {
        key: 'handleHoverLeave',
        value: function handleHoverLeave() {
            this.setState({
                hoveredKey: ''
            });
        }
    }, {
        key: 'getIconDiv',
        value: function getIconDiv(value) {
            var _props2 = this.props,
                onlyIcon = _props2.onlyIcon,
                classPrefix = _props2.classPrefix;

            var menuClassName = classnames(_defineProperty({}, classPrefix + '-menu-icon', true));
            var defaultIconClass = classnames(_defineProperty({}, classPrefix + '-icon-default', true));
            var iconDiv = '';

            if (value.icon) {
                iconDiv = React.createElement(
                    'div',
                    { className: menuClassName },
                    React.createElement('i', { className: value.icon })
                );
            } else if (value.iconImgObj) {
                iconDiv = React.createElement(
                    'div',
                    { className: menuClassName },
                    React.createElement(
                        'i',
                        null,
                        React.createElement('img', { src: value.iconImgObj })
                    )
                );
            } else {
                // 仅显示图标模式下，第一层级留有一个默认图标(考虑到使用者没传入的情况)
                iconDiv = onlyIcon && this.parentItem.indexOf(value.key) > -1 ? React.createElement(
                    'div',
                    { className: menuClassName },
                    React.createElement('i', { className: defaultIconClass })
                ) : '';
            }
            return iconDiv;
        }
    }, {
        key: 'parseDataCreateTree',
        value: function parseDataCreateTree(value) {
            var _this5 = this;

            var _state2 = this.state,
                selectedKeys = _state2.selectedKeys,
                openKeys = _state2.openKeys,
                hoveredKey = _state2.hoveredKey,
                isOnlyShowIcon = _state2.isOnlyShowIcon;
            var _props3 = this.props,
                horizontal = _props3.horizontal,
                defaultHoveredKey = _props3.defaultHoveredKey,
                onlyIcon = _props3.onlyIcon,
                onlyIconWithTips = _props3.onlyIconWithTips,
                tipsLevel = _props3.tipsLevel,
                tipsFixed = _props3.tipsFixed,
                classPrefix = _props3.classPrefix,
                dataSource = _props3.dataSource,
                inNavbar = _props3.inNavbar;

            var isParent = false;
            if (selectedKeys.indexOf(value.key) > -1) {
                isParent = true;
            }

            var itemClass = classnames({
                'menu-item': true,
                'menu-item-hover': hoveredKey === value.key || defaultHoveredKey && defaultHoveredKey.indexOf(value.key) > -1,
                'menu-item-parent': this.isSelectedKeyParent(value.key, dataSource),
                'menu-item-selected': horizontal ? isParent && selectedKeys[selectedKeys.length - 1] === value.key : selectedKeys[0] === value.key
            });
            var arrowClass = '';
            var childrenClass = '';
            var title = '';
            var itemStyle = {};
            var PADDING_LEFT = inNavbar ? 45 : 48;

            if (!horizontal && value.key && this.pathInfo[value.key]) {
                var pathkey = this.pathInfo[value.key].pathkey;
                if (pathkey.length > 1) {
                    itemStyle = {
                        // 固定padding + 层级 * 每级缩进数
                        paddingLeft: PADDING_LEFT + (pathkey.length - 2) * 15
                    };
                }
            }
            // === 箭头展开收起样式
            arrowClass = classPrefix + (horizontal ? '-navbar-arrow' : '-menu-arrow');
            childrenClass = classPrefix + '-menu';

            if (openKeys[value.key]) {
                childrenClass = classnames(childrenClass, 'on');
                // up
                if (!horizontal) {
                    arrowClass = classnames(arrowClass, 'up');
                }
            } else {
                childrenClass = classnames(childrenClass, 'off');
                // down
                if (!horizontal) {
                    arrowClass = classnames(arrowClass, 'down');
                }
            } // == end

            if (typeof value.content === 'string') {
                title = value.content;
            }
            var tipsProps = {
                title: value.content,
                placement: 'right',
                style: {
                    display: 'inline-block'
                },
                level: tipsLevel,
                fixed: tipsFixed,
                preventOverflowEnabled: false,
                popperContainerIsBody: true
            };

            var mainDiv = React.createElement(
                'div',
                {
                    className: itemClass,
                    style: itemStyle,
                    title: !onlyIcon ? title : null,
                    ref: function ref(input) {
                        _this5[value.key] = input;
                    },
                    onMouseEnter: this.handleHoverEnter.bind(this, value),
                    onMouseLeave: this.handleHoverLeave.bind(this),
                    onClick: this.handleSelectOrExpanded.bind(this, value)
                },
                this.getIconDiv(value),
                !(onlyIcon && isOnlyShowIcon) && React.createElement(
                    'span',
                    { key: 'content' },
                    value.content
                ),
                !(onlyIcon && isOnlyShowIcon) && value.children && React.createElement('div', { key: 'arrow', className: arrowClass })
            );

            return React.createElement(
                'li',
                { key: value.key, className: 'tree-menu-group' },
                onlyIcon && onlyIconWithTips && isOnlyShowIcon ? React.createElement(
                    Tips,
                    tipsProps,
                    mainDiv
                ) : mainDiv,
                !(onlyIcon && isOnlyShowIcon) && value.children && React.createElement(
                    'ul',
                    { className: childrenClass },
                    this.renderTreeSidebar(value.children)
                )
            );
        }
    }, {
        key: 'isSelectedKeyParent',
        value: function isSelectedKeyParent(key, dataSource) {
            if (!key || !dataSource || dataSource.length === 0) {
                return false;
            }
            var selectedKeys = this.state.selectedKeys;
            var pathkeyObj = this.pathInfo[selectedKeys[0]];
            return pathkeyObj && pathkeyObj.pathkey.indexOf(key) !== -1;
        }
    }, {
        key: 'renderTreeSidebar',
        value: function renderTreeSidebar(dataSource) {
            var _this6 = this;

            // 树型模式 （层级最多为3时视觉上比较理想)
            return dataSource.map(function (value) {
                return _this6.parseDataCreateTree(value);
            });
        }

        // =============================
        // ========== 平铺模式 ==========
        // =============================

    }, {
        key: 'handleClick',
        value: function handleClick(value) {
            var onHandleClick = this.props.onHandleClick;
            if (value.children) {
                return;
            }
            value.pathkey = this.pathInfo[value.key].pathkey;

            this.setState({
                selectedKeys: value.pathkey
            });

            if (onHandleClick && _.isFunction(onHandleClick)) {
                onHandleClick(value);
            }
        }
    }, {
        key: 'renderStackSidebar',
        value: function renderStackSidebar(dataSource, className) {
            var _this7 = this;

            // 平铺模式
            var classPrefix = this.props.classPrefix;
            var _state3 = this.state,
                selectedKeys = _state3.selectedKeys,
                hoveredKey = _state3.hoveredKey;


            return dataSource.map(function (value) {
                var itemClass = classnames({
                    'menu-item': true,
                    'menu-item-hover': !value.children && hoveredKey === value.key,
                    'menu-item-selected': selectedKeys[0] === value.key
                });
                var title = '';
                if (typeof value.content === 'string') {
                    title = value.content;
                }

                return React.createElement(
                    'li',
                    { key: value.key, className: className },
                    React.createElement(
                        'div',
                        {
                            className: itemClass,
                            title: title,
                            onMouseEnter: function onMouseEnter() {
                                _this7.setState({
                                    hoveredKey: value.key
                                });
                            },
                            onMouseLeave: function onMouseLeave() {
                                _this7.setState({
                                    hoveredKey: ''
                                });
                            },
                            onClick: _this7.handleClick.bind(_this7, value)
                        },
                        value.icon && React.createElement(
                            'div',
                            { className: classPrefix + '-menu-icon' },
                            React.createElement('i', { className: value.icon, title: value.content })
                        ),
                        React.createElement(
                            'span',
                            null,
                            value.content
                        )
                    ),
                    value.children && React.createElement(
                        'ul',
                        { className: classPrefix + '-menu' },
                        _this7.renderStackSidebar(value.children, className)
                    )
                );
            });
        }
    }, {
        key: 'toggleShowIcon',
        value: function toggleShowIcon() {
            this.setState({
                isOnlyShowIcon: !this.state.isOnlyShowIcon
            });
            var onSidebarExpand = this.props.onSidebarExpand;
            if (onSidebarExpand && _.isFunction(onSidebarExpand)) {
                var data = {
                    expandStatus: this.state.isOnlyShowIcon
                };
                onSidebarExpand(data);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames3,
                _this8 = this;

            var _props4 = this.props,
                mode = _props4.mode,
                style = _props4.style,
                className = _props4.className,
                horizontal = _props4.horizontal,
                dataSource = _props4.dataSource,
                onlyIcon = _props4.onlyIcon,
                theme = _props4.theme,
                title = _props4.title,
                logo = _props4.logo,
                classPrefix = _props4.classPrefix,
                fixed = _props4.fixed;

            var isOnlyShowIcon = this.state.isOnlyShowIcon;
            var cx = classnames(className, (_classnames3 = {}, _defineProperty(_classnames3, classPrefix + '-menu-root', true), _defineProperty(_classnames3, classPrefix + '-menu-horizontal', horizontal), _defineProperty(_classnames3, 'only-icon', onlyIcon && isOnlyShowIcon), _defineProperty(_classnames3, classPrefix + '-menu-dark', theme === 'dark'), _defineProperty(_classnames3, classPrefix + '-menu-light', theme === 'light'), _defineProperty(_classnames3, classPrefix + '-menu-fixed', !!fixed), _classnames3));

            var ulStyle = _extends({}, style);

            if (fixed === 'scroll') {
                ulStyle.marginTop = this.state.ulMarginTop;
            }

            return React.createElement(
                'ul',
                {
                    className: cx,
                    style: ulStyle,
                    ref: function ref(root) {
                        _this8.menuRoot = root;
                    }
                },
                (title || logo || onlyIcon) && React.createElement(
                    'li',
                    { className: 'tree-menu-group toggle-icon-box' },
                    logo && (!onlyIcon || onlyIcon && !this.state.isOnlyShowIcon) && React.createElement('img', { className: classPrefix + '-menu-logo', src: logo }),
                    title && (!onlyIcon || onlyIcon && !this.state.isOnlyShowIcon) && React.createElement(
                        'span',
                        { className: classPrefix + '-menu-title' },
                        title
                    ),
                    onlyIcon && React.createElement(
                        'span',
                        { onClick: this.toggleShowIcon.bind(this) },
                        this.state.isOnlyShowIcon ? React.createElement('i', { className: 'toggle-icon icon-right-normal' }) : React.createElement('i', { className: 'toggle-icon icon-left-normal' })
                    )
                ),
                mode === 'stack' ? this.renderStackSidebar(dataSource, 'stack-menu-group') : this.renderTreeSidebar(dataSource)
            );
        }
    }]);

    return Sidebar;
}(Component);

export default Sidebar;


Sidebar.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    mode: PropTypes.oneOf(['tree', 'stack']),
    horizontal: PropTypes.bool,
    selectedKeys: PropTypes.arrayOf(PropTypes.string),
    defaultHoveredKey: PropTypes.arrayOf(PropTypes.string),
    openKeys: PropTypes.arrayOf(PropTypes.string),
    dataSource: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        content: PropTypes.node
    }).isRequired),
    onHandleClick: PropTypes.func,
    onlyIcon: PropTypes.bool,
    onlyIconWithTips: PropTypes.bool,
    theme: PropTypes.oneOf(['dark', 'light']),
    defaultOnlyShowIcon: PropTypes.bool,
    style: PropTypes.object,
    title: PropTypes.string,
    logo: PropTypes.string,
    onSidebarExpand: PropTypes.func,
    tipsLevel: PropTypes.number,
    tipsFixed: PropTypes.bool,
    fixed: PropTypes.oneOf([true, false, 'scroll']),
    scrollMarginTop: PropTypes.number,
    inNavbar: PropTypes.bool
};

Sidebar.defaultProps = {
    classPrefix: classPrefix,
    mode: 'tree',
    dataSource: [],
    theme: 'dark',
    defaultOnlyShowIcon: true,
    onlyIconWithTips: true,
    scrollMarginTop: 60
};